import BybConditionalWrapper from "@Components/common/byb-ds/byb-conditional-wrapper";
import { Box, Dialog, Drawer, DrawerProps, Stack, SwipeableDrawer, useMediaQuery } from "@mui/material";
import Typography from "@mui/material/Typography";
import { SxProps, useTheme } from "@mui/material/styles";

export interface IBybAdaptiveModal {
  children: React.ReactNode;
  open: boolean;
  title?: string;
  onClose: () => void;
  anchor?: "top" | "bottom" | "left" | "right";
  draggable?: boolean;
  sx?: SxProps;
}

const BybAdaptiveModal = ({
  children,
  open,
  title,
  onClose,
  anchor = "bottom",
  draggable = true,
  sx,
}: IBybAdaptiveModal) => {
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));

  let borderRadius;
  if (anchor === "bottom") {
    borderRadius = theme.spacing(2, 2, 0, 0);
  } else if (anchor === "top") {
    borderRadius = theme.spacing(0, 0, 2, 2);
  }

  const drawerProps: DrawerProps = {
    anchor,
    open,
    onClose,
    PaperProps: {
      sx: {
        backgroundColor: theme.palette.dsBase.v100,
        borderRadius,
        padding: theme.spacing(2.5),
        paddingTop: theme.spacing(1.5),
        boxSizing: "border-box",
        maxHeight: anchor === "bottom" || anchor === "top" ? "90vh" : undefined,
        ...sx,
      },
    },
  };

  const commonContent = (
    <>
      {draggable && anchor === "bottom" && isMdDown && (
        <Box
          width={theme.spacing(4)}
          height={theme.spacing(0.5)}
          borderRadius={theme.spacing(1)}
          bgcolor={theme.palette.dsSurface.v400}
          marginBottom={theme.spacing(2)}
          marginX={"auto"}
        />
      )}
      <Stack spacing={2} height={"100%"}>
        {title && (
          <Typography variant="textBase700" textAlign="center" color="dsBase.v200">
            {title}
          </Typography>
        )}
        {children}
      </Stack>
    </>
  );

  return (
    <BybConditionalWrapper
      condition={isMdDown}
      trueWrapper={(children) =>
        draggable ? (
          <SwipeableDrawer {...drawerProps} onOpen={() => {}} onClose={onClose}>
            {commonContent}
          </SwipeableDrawer>
        ) : (
          <Drawer {...drawerProps}>{commonContent}</Drawer>
        )
      }
      falseWrapper={(children) => (
        <Dialog
          open={open}
          onClose={onClose}
          PaperProps={{
            sx: {
              backgroundColor: theme.palette.dsBase.v100,
              borderRadius: theme.spacing(2),
              padding: theme.spacing(2.5),
              maxWidth: "600px",
              width: "100%",
              margin: theme.spacing(2),
              ...sx,
            },
          }}
        >
          {commonContent}
        </Dialog>
      )}
    >
      <></>
    </BybConditionalWrapper>
  );
};

export default BybAdaptiveModal;
